import type { IconProps } from "types";

export const DownloadOutline = ({ width = "20", height = "20" }: IconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.5 15.8332H17.5V17.4998H2.5V15.8332ZM10.8333 10.9765L15.8925 5.9165L17.0708 7.09484L10 14.1665L2.92917 7.09567L4.1075 5.9165L9.16667 10.9748V1.6665H10.8333V10.9765Z"
        fill="#141516"
      />
    </svg>
  );
};
